<template>
  <div style="margin: 0 30px">
    <el-form :model="queryParams" label-width="84px">
      <div>
        <div class="title">基本信息：</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同编号：">{{ queryParams.contractCode }}</el-form-item>
          </el-col>
          <el-col :span="12">
            开票金额
            <el-tooltip content="开票金额为客户承担部分" placement="top">
              <span class="el-icon-info" style="color: #C1C5CD"></span>
            </el-tooltip>
            ：
            {{ queryParams.billingMoney|priceFilterNum }}
          </el-col>
          <el-col :span="24">
            <el-form-item label="开票类型：">{{ queryParams.billingType }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票类型：">
              <el-select v-model="queryParams.invoiceType">
                <el-option label="普通发票" value="普通发票"></el-option>
                <el-option label="专用发票" value="专用发票"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div style="width:84px;text-align:right;display: inline-block;">
              税率
              <el-tooltip content="开票税率请提前与财务确认" placement="top">
                <span class="el-icon-info" style="color: #C1C5CD"></span>
              </el-tooltip>：
            </div>
            <el-select
              v-model="queryParams.taxAmountCommit"
              style="width: calc(100% - 84px);display: inline-block;"
            >
              <el-option
                :label="item.str"
                :value="item.str"
                :key="i"
                v-for="(item,i) in queryParams.taxAmount"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司名称：">
              <el-input disabled v-model="queryParams.cusName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税号：">
              <el-input v-model="queryParams.taxNumber" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号：" :rules="filter_rules({required:true})">
              <el-input v-model="queryParams.bankNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票地址：" :rules="filter_rules({required:true})">
              <el-input v-model="queryParams.invoiceAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行：" :rules="filter_rules({required:true})">
              <el-input v-model="queryParams.bankOpen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票电话：" :rules="filter_rules({required:true})">
              <el-input  @input.native="onInput" v-model="queryParams.invoicePhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="开票备注：">
              <el-input v-model="queryParams.invoiceMark" type="textarea" :rows="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!--------------------------------------- 收票信息 -------------------------------------->
      <el-row style="margin-top:10px">
        <el-col :span="12" class="title" style="margin-top: 0">收票信息：</el-col>
        <el-col :span="12" style="text-align:right">
          <el-button @click="onModify" v-show="!isShow">修改</el-button>
          <el-button @click="onSave" v-show="isShow">保存</el-button>
        </el-col>
      </el-row>
      <div v-show="!isShow">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收票人：">{{ params.ciRecevier }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">{{ params.ciRecevierPhone }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收票地址：">{{ params.ciRecevierProvince }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：">{{ params.ciRecevierAddress }}</el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-show="isShow">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收票人：">
              <el-input v-model="params.ciRecevier"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">
              <el-input @input.native="onInput" v-model="params.ciRecevierPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收票地址：">
              <el-address
                ref="addressRefs"
                :provinceEdit="provinceEdit"
                :city="city"
                :district="district"
                @changAddress="changAddress($event)"
              ></el-address>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：">
              <el-input v-model="params.ciRecevierAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div>
      <el-button type="primary" @click="onInvoice">申请开票</el-button>
    </div>
    <div style="color: #D35E5E;font-size: 12px;margin-top:14px;">* 开票审批通过后请及时联系处理人领取</div>

    <!-------------- 修改客户开票信息 确认 -------------->
    <el-dialog :visible.sync="disableDialog" title="修改开票信息" @close='onSubmit' append-to-body width="414px">
      <span style="padding-left:30px;">开票信息已修改，请问是否同步更新客户资料-开票信息？</span>
      <span slot="footer" class="dialog-center">
        <el-button type="primary" @click="onSubmit(1)">确 定</el-button>
        <el-button @click="disableDialog=false">取 消</el-button>
      </span>
    </el-dialog>
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      title="确认开票"
      content="开票申请发起后不可撤回，是否确认开票？"
    ></open-or-close>
  </div>
</template>

<script>
import address from '@/components/Address/index'
import OpenOrClose from '@/components/OpenOrClose/index'
import { perCentFilterL } from '@/util/filterCommon'
import { customerInvoice, forfeitureInvoiceCommit } from '@/api/sell/sellManage'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'el-address': address
  },
  data() {
    return {
      returnGoods: {},
      queryParams: {},
      params: {},
      provinceEdit: {},
      city: {},
      district: {},
      isShow: false,
      disableDialog: false
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号-
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    onUpdataState() {
      const obj = {
        forfeitureInvoiceBasicsVo: this.queryParams,
        customerInvoice: this.params,
        orderContractSalereturnGoods: this.returnGoods
      }
      forfeitureInvoiceCommit(obj).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('已申请开票，请等待审核！')
          this.$emit('getList', this.queryParams.ocbId, 2, true)
        }
      })
    },
    onInvoice() {
      if (this.isShow) {
        this.$message.error('请保存收票信息')
      } else {
        if (
          this.queryParams.invoiceType &&
          this.queryParams.taxAmountCommit &&
          this.queryParams.bankNumber &&
          this.queryParams.invoiceAddress &&
          this.queryParams.bankOpen &&
          this.queryParams.invoicePhone &&
          this.params.ciRecevier &&
          this.params.ciRecevierPhone &&
          this.params.ciRecevierProvince &&
          this.params.ciRecevierAddress
        ) {
          this.$refs.OpenOrCloseRefs.onInitial()
        } else {
          this.$message.error('必填项不可为空！')
        }
      }
    },
    init(obj) {
      this.params = obj.customerInvoice
      this.returnGoods = obj.orderContractSalereturnGoods
      this.queryParams = obj.forfeitureInvoiceBasicsVo
      this.queryParams.invoiceMark = null
      this.queryParams.billingType = '罚没金开票'
      this.queryParams.taxAmount.forEach((ele) => {
        ele.str = ele.taxName + ' ' + perCentFilterL(ele.taxCount)
      })
    },
    onSave() {
      if (
        this.params.ciRecevier &&
        this.params.ciRecevierPhone &&
        this.params.ciRecevierProcode &&
        this.params.ciRecevierAddress
      ) {
        this.disableDialog = true
      } else {
        this.$message.error('信息请填写完整')
      }
    },
    onModify() {
      this.isShow = true
      if (this.params.ciRecevierProcode && this.params.ciRecevierProvince) {
        const recParams = this.$analysisAddress(
          this.params.ciRecevierProcode,
          this.params.ciRecevierProvince
        )
        this.provinceEdit = recParams.province
        this.city = recParams.city
        this.district = recParams.district
      }
    },
    changAddress(val) {
      // 收件人地址改变
      this.params.ciRecevierProvince = val.name
      this.params.ciRecevierProcode = val.code
    },
    // 修改客户开票信息
    onSubmit(num) {
      if (num) {
        this.params.cbId = this.$route.query.cusId
        customerInvoice(this.params).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('修改成功')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
      this.isShow = false
      this.disableDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: 500;
  color: #4e555b;
  line-height: 24px;
  margin: 20px 0;
}
</style>
